
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconEyeOffSelector = "fhi-icon-eye-off";

/**
 * ## FhiIconEyeOff
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-eye-off
 * @element fhi-icon-eye-off
 */
@customElement(FhiIconEyeOffSelector)
export class FhiIconEyeOff extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M1.47 1.47a.75.75 0 0 1 1.06 0l20 20 .052.056a.75.75 0 0 1-1.055 1.056l-.058-.052-4.108-4.108a11.5 11.5 0 0 1-4.142 1.264 11.5 11.5 0 0 1-11.728-6.768l-.122-.284-.01-.025a1.75 1.75 0 0 1 0-1.218l.01-.025a11.5 11.5 0 0 1 3.956-4.98L1.469 2.53a.75.75 0 0 1 0-1.06m4.934 5.995a10 10 0 0 0-3.64 4.453.25.25 0 0 0 0 .162 10 10 0 0 0 10.296 6.113 10 10 0 0 0 3.182-.89l-2.175-2.175a3.749 3.749 0 0 1-5.195-5.195zm4.708-3.18a11.495 11.495 0 0 1 11.332 6.65l.187.43.01.025.048.149a1.75 1.75 0 0 1 0 .92l-.048.15-.01.024a11.5 11.5 0 0 1-1.545 2.664l-.05.057a.75.75 0 0 1-1.134-.977l.201-.269a10 10 0 0 0 1.134-2.03.25.25 0 0 0-.002-.165A9.994 9.994 0 0 0 10.822 5.82l-.076.006a.75.75 0 0 1-.102-1.495zm-1.14 6.747a2.25 2.25 0 0 0-.222.988 2.25 2.25 0 0 0 2.23 2.23c.345.003.682-.076.987-.222z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
